import { useEffect, useState } from "react";

const External404Redirect = () => {
  useEffect(() => {
    window.location.href = "/404";
  }, []);
  return null;
};

export default External404Redirect;